import { Component } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import I18n from 'I18n';
import UIApplication from 'UIComponents/app/UIApplication';
import BrowserVersionWrapper from 'LoginUI/components/alerts/BrowserVersionWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ComplianceLink } from 'LoginUI/components/Compliance/ComplianceLink';
import { checkSafeOpener } from 'LoginUI/utils/checkSafeOpener';
import Compliance from '../../Compliance/Compliance';
import { getIsMobileCalendarConnect, getQueryParamValues } from 'LoginUI/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class HubspotApp extends Component {
  componentDidMount() {
    document.title = I18n.text('login.title');
    const {
      search
    } = this.props.location;
    const query = getQueryParamValues(search, ['useDark', 'allowFbSignup', 'loginRedirectUrl']);
    const {
      useDark,
      allowFbSignup,
      loginRedirectUrl
    } = query;
    if (useDark === 'true') {
      const fullPage = document.getElementsByClassName('page')[0];
      fullPage.className += ' dark-bg';
    }
    if (allowFbSignup) {
      const fullPage = document.getElementsByClassName('page')[0];
      fullPage.className += ' fb-crm-signup';
    }
    checkSafeOpener({
      loginRedirectUrl: loginRedirectUrl
    });
  }
  render() {
    const isMobileCalendarConnect = getIsMobileCalendarConnect();
    return /*#__PURE__*/_jsxs(UIApplication, {
      name: "LoginUI",
      children: [!this.props.isMobileLogin && /*#__PURE__*/_jsx(Compliance, {
        pathname: this.props.location.pathname
      }), /*#__PURE__*/_jsx(BrowserVersionWrapper, {
        children: this.props.children
      }), /*#__PURE__*/_jsx(View, {
        as: "footer",
        padding: "100",
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsxs(Text, {
          typography: "detail-100",
          textAlign: "center",
          children: ["\xA9", new Date().getFullYear(), " HubSpot, Inc.", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.footer.allRightsReserved"
          }), ' ', /*#__PURE__*/_jsx(Link, {
            href: `https://legal.hubspot.com/privacy-policy${this.props.isMobileLogin || isMobileCalendarConnect ? '?hideNav=true' : ''}`,
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.footer.privacy"
            })
          }), /*#__PURE__*/_jsx(ComplianceLink, {})]
        })
      })]
    });
  }
}
export default HubspotApp;